import '@fortawesome/fontawesome-free/css/all.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			dark: {
				primary: '#8C735A',
				secondary: '#4B5320',
				accent: '#8C735A',
			},
		},
		dark: true,
	},
    icons: {
        iconfont: 'md' || 'fa'
    }
});
